<template>
  <div class="welcome">
    <h4 class="title">
      {{ title }}
    </h4>

    <div v-if="cardItems?.length" class="items">
      <div v-for="(card, itemIndex) in cardItems" :key="itemIndex" class="item">
        <div class="title">{{ card.title }}</div>
        <div class="sub-title">{{ card.topLabel }}</div>
        <div class="picture">
          <img v-lazy-load  :data-src="card.image" class="img" :width="142" :height="142" alt="" />
        </div>

        <div class="actions">
          <button-base
            type="primary"
            size="sm"
            @click="isLoggedIn ? openWalletModal('deposit') : openModalSync(ModalName.SIGN_IN)"
          >
            {{ card.buttonLabel }}
          </button-base>

          <button-base type="ghost" size="sm" :url="card.link.url">
            {{ card.link.label }}
          </button-base>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ModalName } from '@skeleton/consts/modals';

  import type { IWelcomeBonusesPage } from '~/types';

  const props = defineProps<{
    title: string;
    cardItems: IWelcomeBonusesPage['welcome']['items'];
  }>();

  const profileStore = useProfileStore();
  const { openModalSync } = useModalStore();
  const { openWalletModal } = useTransactionStore();
  const { isLoggedIn } = storeToRefs(profileStore);

  onMounted(() => {
    props.cardItems.forEach((card, index) => {
      const img = new Image();
      img.src = card.image;
    });
  });
</script>

<style src="~/assets/styles/components/welcome-package/card.scss" lang="scss" />
